import React, { useEffect, Suspense } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header";
import Banner from "../../assets/contact/contact-people.svg";
import Facebook from "../Icons/facebook";
import InstagramFill from "../Icons/Instagram_Fill";
import Linkedin from "../Icons/Linkedin";
import Email from "../Icons/Email";
import Phone from "../Icons/Phone";
import Location from "../Icons/Location";
import Footer from "../Footer";
import { SuspenseImg } from "../../helpers/SuspenseImg";
import ContactFrom from "../ContactFrom/index";

const Contact = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Header />
      <section className="bg-Gray-50">
        <section className="mt-16">
          <div className="bg-Gray-50 pt-8">
            <div className="mid-container">
              <div className="container sm:container md:container lg:container w-full mx-auto">
                <div className="flex flex-col md:flex-row items-center justify-center md:justify-between">
                  <div className="md:w-3/5 w-full">
                    <h2 className="md:text-5xl text-3xl leading-tight font-avenirBook pb-2">
                      Queries, applications
                    </h2>
                    <span className="font-avenirBook text-Gray-600 md:py-2 leading-relaxed text-base md:text-2xl block">
                      or if you’d just want to say{" "}
                      <span className="font-avenirHeavy text-pink-500">
                        hello!
                      </span>
                    </span>
                  </div>
                  <div className="md:w-2/5	w-full">
                    <Suspense fallback="Loading...">
                      <SuspenseImg alt="" src={Banner} />
                    </Suspense>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="-mt-6 relative z-50 md:pb-24 pb-12">
          <div className="mid-container">
            <div className="container sm:container md:container lg:container w-full mx-auto">
              <div className="md:rounded-lg  shadow-lg bg-white flex flex-col flex-col md:flex-row">
                <div className="md:w-3/6 w-full bg-lightGray-900 md:rounded-l-lg rounded-none md:order-1 order-2">
                  <div className="p-5 md:py-10 md:px-14 text-white">
                    <div className="flex flex-row items-center">
                      <Email />{" "}
                      <a
                        href="mailto:sales@2mnordic.com"
                        className="px-2 font-avenirBook text-sm"
                      >
                        sales@2mnordic.com
                      </a>
                    </div>
                    <div className="flex flex-row items-center py-8 border-b border-lightGray-600 ">
                      <Phone />{" "}
                      <a
                        href="tel:+46 768 529671"
                        className="px-2 font-avenirHeavy text-xl"
                      >
                        +46 768 529671
                      </a>
                    </div>
                    <div className="pt-4">
                      <div className="flex flex-row w-full pt-6">
                        <Location
                          width="20"
                          height="20"
                          className="text-white"
                        />
                        <div className="px-5 w-full">
                          <h5 className="text-lg font-avenirHeavy">
                            Gothenburg
                          </h5>
                          <div className="flex md:flex-row flex-col w-full">
                            <div className="md:w-3/6 w-full">
                              <span className="text-white opacity-50 font-avenirBook py-2 text-sm">
                                Postal address
                              </span>

                              <div className="text-white text-sm font-avenirBook leading-relaxed md:pt-2">
                                <span className="block"> Box 4054</span>
                                <span className="block">
                                  {" "}
                                  42254 Hisings Backa
                                </span>
                                <span className="block">Sweden</span>
                              </div>
                            </div>
                            <div className="md:w-3/6 w-full md:pt-0 pt-4">
                              <span className="text-white opacity-50 font-avenirBook py-2 text-sm">
                                Visiting address
                              </span>

                              <div className="text-white text-sm font-avenirBook leading-relaxed pt-2">
                                <span className="block">Åvägen 24</span>
                                <span className="block">412 51 Göteborg</span>
                                <span className="block">Sweden</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-row pt-8">
                        <Location
                          width="20"
                          height="20"
                          className="text-white"
                        />
                        <div className="px-5">
                          <h5 className="text-lg font-avenirHeavy">
                            Helsingborg
                          </h5>
                          <div className="text-white text-sm font-avenirBook leading-relaxed pt-2">
                            <span className="block">Redaregatan 48</span>
                            <span className="block">
                              {" "}
                              252 36 Helsingborg{" "}
                            </span>
                            <span className="block">Sweden</span>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-row pt-6">
                        <Location
                          width="20"
                          height="20"
                          className="text-white"
                        />
                        <div className="px-5">
                          <h5 className="text-lg font-avenirHeavy">New York City</h5>
                          <div className="text-white text-sm font-avenirBook leading-relaxed pt-2">
                            <span className="block">
                             201 Marin Blvd.{" "}
                             {" "}
                             Jersey City, NJ 07302
                             {" "}
                             USA
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-row pt-6">
                        <Location
                          width="20"
                          height="20"
                          className="text-white"
                        />
                        <div className="px-5">
                          <h5 className="text-lg font-avenirHeavy">Chennai</h5>
                          <div className="text-white text-sm font-avenirBook leading-relaxed pt-2">
                            <span className="block">
                              4 B, Arputhalaya, Vengaivasal, Chennai 600126,
                              India
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="md:w-3/6 w-full md:order-2 order-1">
                  <div className="px-10 md:py-10 py-4">
                    <h3 className="font-avenirNextRegular text-blue-800 text-2xl pt-3">
                      Write to us
                    </h3>
                    <ContactFrom className="contact-form" />
                  </div>
                  <div className="pb-10">
                    <div className="flex flex-row items-center justify-center">
                      <div className="bg-white rounded-lg px-3 py-3 mx-2 border border-Gray-150">
                        <a
                          href="https://www.facebook.com/2MNordic"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Follow us on Facebook"
                        >
                          <Facebook className="cursor-pointer text-blue-600" />
                        </a>
                      </div>
                      <div className="bg-white rounded-lg px-3 py-3 mx-1 border border-Gray-150">
                        <a
                          href="https://www.instagram.com/2mnordic/"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Follow us on Instagram"
                        >
                          <InstagramFill
                            className="cursor-pointer"
                            width="20"
                            height="20"
                          />
                        </a>
                      </div>
                      <div className="bg-white rounded-lg px-3 py-3 mx-1 border border-Gray-150">
                        <a
                          href="https://www.linkedin.com/company/2mnordic-it-consulting-ab/"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Follow us on Linkedin"
                        >
                          <Linkedin className="cursor-pointer text-blue-700" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <Footer />
    </>
  );
};

export default Contact;
